import React, { useState, useMemo } from "react";
import ToolTip from "../../components/tooltip";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function CollapseTable({ tableHeader, tableData, type, showTitle }) {
  const [showTable, setShowTable] = useState([]);
  const showTableHandler = (e) => {
    if (typeof e !== "string") {
      if (showTable?.length === 0 || e !== showTable) {
        setShowTable(e);
      } else {
        setShowTable([]);
      }
    }
  };

  const column = useMemo(() => {
    return tableHeader.map((item, index) => {
      return {
        id: index,
        label: item,
        key: item,
        width: index === 0 ? "250px" : "auto",
        align: index === 0 ? "left" : "center",
      };
    });
  }, [tableHeader]);

  return (
    <>
      <Paper
        className={"w-100 mt-3 vir-table-border"}
        sx={{
          backgroundColor: "background.paper",
          boxShadow: "none",
          "& .MuiTableContainer-root": {
            boxShadow: "none",
            backgroundColor: "background.paper",
          },
        }}
      >
        <TableContainer component={Paper} sx={{ maxHeight: 700 }}>
          <Table stickyHeader aria-label="collapsible table">
            <TableHead sx={{ position: "relative", zIndex: "3" }}>
              <TableRow>
                {column?.map((header, index) => {
                  return (
                    <TableCell
                      variant="head"
                      align={header.align}
                      key={`table-header-${index}`}
                      sx={{
                        padding:
                          header.align === "left"
                            ? "10px 0 10px 10px"
                            : "10px 0",
                        fontSize: "0.8em",
                        fontWeight: "700",
                        height: "55px",
                        minWidth: header.width,
                        textTransform: "uppercase",
                        backgroundColor: "rgba(220, 223, 228)",
                      }}
                    >
                      <span className="p-2 text-center">
                        <span className="point">{header.label}</span>
                      </span>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData?.map((item, index) => {
                return (
                  <React.Fragment key={`table-row-${index}`}>
                    <TableRow
                      key={index}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      {item?.url ? (
                        <TableCell
                          className={
                            type === "poorly_formatted" ? "length-url-lmt" : ""
                          }
                          onClick={() => showTableHandler(item.url)}
                        >
                          {typeof item.url === "string" ? (
                            <div className="text-max-lmt">
                              {!showTitle && (
                                <h1 className="heading-small font-regular mb-0">
                                  {item?.title}
                                </h1>
                              )}
                              <span className="d-flex align-items-center">
                                <a
                                  href={
                                    item.url === "undefined" ? "#" : item.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{
                                    alignItems: "center",
                                    width: "100%",
                                    // maxWidth: "500px",
                                    color: !showTitle
                                      ? "#365486"
                                      : "rgba(0, 0, 0, 0.8)",
                                  }}
                                  className={
                                    type === "poorly_formatted"
                                      ? `d-inline-flex ${
                                          !showTitle ? "text-max-lmt" : ""
                                        }`
                                      : `${!showTitle ? "text-max-lmt" : ""}`
                                  }
                                >
                                  {" "}
                                  {type === "poorly_formatted" ? (
                                    <ToolTip title={item?.url}>
                                      <span
                                        className="length-url-lmt"
                                        style={{
                                          color: "#365486",
                                          maxWidth: "95%",
                                        }}
                                      >
                                        {item?.url}
                                      </span>
                                    </ToolTip>
                                  ) : (
                                    item?.url
                                  )}
                                  <OpenInNewIcon
                                    sx={{
                                      fontSize: "13px",
                                      marginLeft: "2px",
                                      color: "#365486 !important",
                                    }}
                                  />
                                </a>
                              </span>
                            </div>
                          ) : item.url?.length === 1 ? (
                            <a
                              href={item.url === "undefined" ? "#" : item.url}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                color: !showTitle
                                  ? "#365486"
                                  : "rgba(0, 0, 0, 0.8)",
                              }}
                              className={
                                type === "poorly_formatted"
                                  ? "w-100 d-inline-flex"
                                  : ""
                              }
                            >
                              {" "}
                              {type === "poorly_formatted" ? (
                                <ToolTip title={item?.url[0]}>
                                  <span
                                    className="length-url-lmt"
                                    style={{ maxWidth: "100%" }}
                                  >
                                    {item?.url[0]}{" "}
                                  </span>
                                </ToolTip>
                              ) : (
                                item?.url[0]
                              )}
                            </a>
                          ) : (
                            <button
                              className="site-audit-url py-1 px-2"
                              style={{
                                background: "#fff",
                                color: "rgb(233, 86, 85)",
                                width: "100px",
                              }}
                            >
                              {item.url.length}{" "}
                              <span className="mx-1">pages</span>
                              <i
                                className="fa-solid fa-angle-down ms-2"
                                title="download Pdf"
                              ></i>
                            </button>
                          )}
                        </TableCell>
                      ) : null}

                      {item?.desc ? (
                        <TableCell className="text-start">
                          {item.desc}
                        </TableCell>
                      ) : null}
                    </TableRow>

                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={2}
                      >
                        <Collapse
                          in={item?.url === showTable && showTable?.length > 0}
                          timeout="auto"
                          unmountOnExit
                          sx={{ maxHeight: 400, overflowY: "scroll" }}
                        >
                          {showTable?.map((res, ind) => {
                            return (
                              <TableRow
                                key={`${ind}-collapse-row-${item.title}`}
                              >
                                <TableCell>
                                  <div className="w-100">
                                    {item?.title ? (
                                      <span>{item?.title}</span>
                                    ) : null}
                                    <span className="d-flex align-items-center">
                                      <a
                                        href={res || "#"}
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                          alignItems: "center",
                                          color: "#365486",
                                        }}
                                        className={
                                          "d-inline-flex text-max-lmt w-100"
                                        }
                                      >
                                        <ToolTip title={res || ""}>
                                          <span
                                            className="length-url-lmt"
                                            style={{
                                              color: "#365486",
                                              maxWidth: "95%",
                                            }}
                                          >
                                            {res || ""}
                                          </span>
                                        </ToolTip>
                                        <OpenInNewIcon
                                          sx={{
                                            fontSize: "13px",
                                            marginLeft: "2px",
                                            color: "#365486 !important",
                                          }}
                                        />
                                      </a>
                                    </span>
                                  </div>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}

export default CollapseTable;
